export default function(to,next,store){
    if (!store.state.isLoggedIn){
        next({ path: '/login', query: { redirect: to.fullPath } });
    }
    else{
        next();
    }
}